module.exports = __webpack_public_path__ + "img/josh-hild-1407748-unsplash.c9ac034d.jpg";